export default {
    namespaced: true,
    state: {
        buttons: [
            {
                route: 'home',
                src: require('@/assets/images/decoration/link-icon-hi.svg'),
                label: 'Home',
                loggedIn: false,
                loggedOut: true,
            },
            {
                route: 'flowers',
                src: require('@/assets/images/decoration/link-icon-flowers.svg'),
                label: 'Flowers',
                loggedIn: false,
                loggedOut: true,
            },
            {
                route: 'delivery',
                src: require('@/assets/images/decoration/link-icon-van.svg'),
                label: 'Delivery',
                loggedIn: false,
                loggedOut: true,
            },
            {
                route: 'arranging',
                src: require('@/assets/images/decoration/link-icon-vase.svg'),
                label: 'Arranging',
                loggedIn: false,
                loggedOut: true,
            },
            {
                route: 'account.dashboard',
                src: require('@/assets/images/decoration/link-icon-hi.svg'),
                label: 'Dashboard',
                loggedIn: true,
                loggedOut: false,
            },
            {
                route: 'account.gifting.choose-your-gift',
                src: require('@/assets/images/decoration/link-icon-hi.svg'),
                label: 'Gifting',
                loggedIn: true,
                loggedOut: false,
            },
            {
                route: 'account.shop',
                src: require('@/assets/images/decoration/link-icon-hi.svg'),
                label: 'Shop',
                loggedIn: true,
                loggedOut: false,
            },
            {
                route: 'faq.categories',
                src: require('@/assets/images/decoration/link-icon-hi.svg'),
                label: 'Help',
                loggedIn: true,
                loggedOut: false,
                isMobile: false,
            },

        ],
    },
    getters: {
        // Gets buttons for navigation bar.
        getButtons: state => state.buttons,
    },
};
